// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".testimonial {\n    box-shadow: 10px 5px 20px black;\n    max-width: 18em;\n    margin: 0em 1.5em 5em 0em;\n}\n\n.testimonial:hover {\n    box-shadow: 10px 5px 35px black;\n}\n\n.testimonial > p {\n    padding: 0.2em 1em;\n}\n\n.testimonial span {\n    display: block;\n    color: #D4AF37;\n    text-align: right;\n    padding: 1em .2em 0em 0em;\n}\n\n@media screen and (max-width: 720px) {\n    .testimonial {\n        margin: 1.5em 0em 0em 0em;\n    }\n}\n", ""]);
// Exports
module.exports = exports;
